import { render } from "./NTextDelimiter.vue?vue&type=template&id=caeb5e50&ts=true"
import script from "./NTextDelimiter.vue?vue&type=script&lang=ts"
export * from "./NTextDelimiter.vue?vue&type=script&lang=ts"

import "./NTextDelimiter.vue?vue&type=style&index=0&id=caeb5e50&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__